var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-office"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office",
    clipPath: "url(#clip-office)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "building",
    transform: "translate(-2.728 -2.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40443",
    "data-name": "Path 40443",
    d: "M19.784,19.113H18.441V3.672a.671.671,0,0,0-.947-.611L7.7,7.412V5.686a.671.671,0,1,0-1.343,0V8.009l-.947.423a.671.671,0,0,0-.4.611v10.07H3.671a.671.671,0,1,0,0,1.343H19.784a.671.671,0,1,0,0-1.343ZM6.357,9.479,17.1,4.706V19.113H13.742V15.756a.671.671,0,0,0-.671-.671H10.385a.671.671,0,0,0-.671.671v3.357H6.357ZM12.4,19.113H11.056V16.428H12.4Z",
    transform: "translate(0)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40444",
    "data-name": "Path 40444",
    d: "M14.028,15.341a.671.671,0,1,0-.477-.195A.7.7,0,0,0,14.028,15.341Zm3.357,0a.671.671,0,1,0-.477-.195A.7.7,0,0,0,17.385,15.341Zm-6.237-1.148a.671.671,0,1,0,.195.477A.671.671,0,0,0,11.148,14.193Z",
    transform: "translate(-2.3 -3.612)",
    fill: "#434343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficesIcon);
export default __webpack_public_path__ + "static/media/offices-icon.e67583171d3d7b9e7537b2f8255144c2.svg";
export { ForwardRef as ReactComponent };